import { render, staticRenderFns } from "./allMaterialsPage.vue?vue&type=template&id=76588ea6&scoped=true&"
import script from "./allMaterialsPage.vue?vue&type=script&lang=js&"
export * from "./allMaterialsPage.vue?vue&type=script&lang=js&"
import style0 from "./allMaterialsPage.vue?vue&type=style&index=0&id=76588ea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76588ea6",
  null
  
)

export default component.exports